import axios from '../utils/axios'

// 验证手机是否注册
export const api_userIsExist = data => {
  return axios({
    url: '/api-auth/thirdPartLogin/public/userIsExist',
    method: 'post',
    data
  })
}

// 发送验证码
export const api_sendSms = data => {
  return axios({
    url: '/api-auth/oauth/user/sendSms',
    method: 'post',
    data
  })
}

// 密码登录
export const api_userToken = data => {
  return axios({
    url: '/api-auth/oauth/user/token',
    method: 'post',
    data
  })
}

// 手机登录
export const api_loginByphone = data => {
  return axios({
    url: '/api-auth/oauth/user/loginByphone',
    method: 'post',
    data
  })
}

// 手机找回密码
export const api_findPwdByPhonee = data => {
  return axios({
    url: '/api-auth/oauth/user/findPwdByPhone',
    method: 'post',
    data
  })
}

// 手机注册
export const api_registerPhone = data => {
  return axios({
    url: '/api-auth/oauth/user/registerPhone',
    method: 'post',
    data
  })
}

// 修改手机
export const api_relatedPhone = data => {
  return axios({
    url: '/api-auth/oauth/user/relatedPhone',
    method: 'post',
    data
  })
}

// 获取用户id
export const api_appuserinfo = data => {
  return axios({
    url: '/api-auth/oauth/appuserinfo',
    method: 'post',
    data
  })
}

// 修改个人信息
export const api_update_userInfo = data => {
    return axios({
      url: '/api-auth/oauth/userinfo/modifyUserInfo',
      method: 'post',
      data
    })
  }
// 发送验证码
export const  api_send_verificaCode = data => {
    return axios({
      url: '/api-auth/oauth/user/sendSms',
      method: 'post',
      data
    })
  }

